/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DateDisplay from 'app/components/common/DateDisplay.jsx';
import Draggable from 'react-draggable';
import { Breakpoint } from 'react-socks';
import ComponentWithRouter from 'app/components/Routers/ComponentWithRouter.jsx';
import { compose } from 'redux';

class RateLimitModal extends React.Component {
    constructor(props) {
        super(props);

        this.confirmClick = this.confirmClick.bind(this);
        this.draggableRef = React.createRef();

        this.state = {
            version: 1
        };

    }

    componentDidMount() {
        let version = 'bigbutton';

        // if (parseInt(this.props.user.detail.id) % 2) {
        //     version = 'bigbutton';
        // } else {
        //     version = 'regbutton';
        // }

        this.setState({
            version
        });

        // if (dataLayer) {
        //     dataLayer.push({
        //         'event': 'promotionView',
        //         'ecommerce': {
        //             'promoView': {
        //                 'promotions': [
        //                     {
        //                         'id': 'rate_limit_modal',
        //                         'name': 'Rate Limit Modal',
        //                         'creative': 'rate_limit_modal.' + version,
        //                         'position': 'app-main'
        //                     }
        //                 ]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': 'rate_limit_modal',
        //         'promotion_name': 'Rate Limit Modal',
        //         'creative_name': 'rate_limit_modal.' + version,
        //         'creative_slot': 'app-main',
        //         items: [
        //             {
        //                 item_id: 'dlvrit_1',
        //                 item_name: 'dlvr.it premium plan',
        //                 price: 1.00,
        //                 quantity: 1
        //             }
        //         ]
        //     });
        // }

        if (gtag) {
            gtag('event', 'view_promotion', {
                'promotion_id': 'rate_limit_modal',
                'promotion_name': 'Rate Limit Modal',
                'creative_name': 'rate_limit_modal.' + version,
                'creative_slot': 'app-main',
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });
        }

        if (moment) {
            moment.relativeTimeRounding(Math.ceil);
        }

        window.location.hash = "ratelimit";

    }

    componentDidUpdate(prevProps, prevState) {
        // catch the back button
        if (window.location.hash !== "#ratelimit") {
			this.props.cancelAction();
		}
    }

    componentWillUnmount() {
        if (window.location.hash.match("#ratelimit")) {
			let cleanUrl = window.location.href.substring(0, window.location.href.indexOf("#"));
            window.history.replaceState({}, '', cleanUrl);
		}
    }

    confirmClick(e) {
        // if (dataLayer) {
        //     dataLayer.push({
        //         'event': 'promotionClick',
        //         'ecommerce': {
        //             'promoClick': {
        //                 'promotions': [
        //                     {
        //                         'id': 'rate_limit_modal',
        //                         'name': 'Rate Limit Modal',
        //                         'creative': 'rate_limit_modal.' + this.state.version,
        //                         'position': 'app-main'
        //                     }
        //                 ]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': 'rate_limit_modal',
        //         'promotion_name': 'Rate Limit Modal',
        //         'creative_name': 'rate_limit_modal.' + this.state.version,
        //         'creative_slot': 'app-main',
        //         items: [
        //             {
        //                 item_id: 'dlvrit_1',
        //                 item_name: 'dlvr.it premium plan',
        //                 price: 1.00,
        //                 quantity: 1
        //             }
        //         ]
        //     });
        // }

        if (gtag) {
            gtag('event', 'select_promotion', {
                'promotion_id': 'rate_limit_modal',
                'promotion_name': 'Rate Limit Modal',
                'creative_name': 'rate_limit_modal.' + this.state.version,
                'creative_slot': 'app-main',
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });

            this.props.persistData('gaPromo', {
                'promotion_id': 'rate_limit_modal',
                'promotion_name': 'Rate Limit Modal',
            });
        }

        this.props.confirmAction(e);
    }

    render() {
        let postResetTs = this.props.user.detail.postLimitReset * 1000,
            now = moment(),
            content = null,
            headline = "Posting Stopped",
            days = moment(postResetTs).diff(now, 'days'),
            buttonStyle = {};

        /*
        <DateDisplay dateTime={postResetTs} dateTimeFormat="relative" user={this.props.user} timezone={this.props.user.detail.timezone}/>
         */

        buttonStyle = {
            'textTransform': 'capitalize',
            'fontSize': '16px'
        };

        content = (
            <div ref={this.draggableRef} className="dlvr-delete-modal rate-limit">
                <div className="dlvr-delete-close" onClick={this.props.cancelAction} role="button" aria-label="cancel">
                    <i className="fa fa-times"></i>
                </div>
                <div className={`dlvr-delete-copy`}>
                    <div className="rate-limit-icon">
                        <i className="ion-android-alert"></i>
                    </div>
                    <div className="rate-limit-copy">
                        <h2>{headline}</h2>
                        <p>You’ve reached your maximum of 50 monthly posts per social profile.</p>
                        <p>{`Your social media posting is stopped for ${days} days.`}</p>
                    </div>
                </div>
                <div className="dlvr-delete-actions">
                    <button className={`btn-upgrade action-upgrade`} style={buttonStyle} onClick={this.confirmClick}>
                        Resume Posting
                    </button>
                </div>
            </div>
        );

        return (
            <div className="dlvr-modal">
                <Breakpoint desktop only>
                    <Draggable nodeRef={this.draggableRef} handle=".dlvr-delete-modal" cancel=".action-upgrade, .dlvr-delete-close">
    					{content}
    				</Draggable>
                </Breakpoint>
				<Breakpoint mobile only>
                    {content}
                </Breakpoint>
			</div>
        );
    }

};

RateLimitModal.displayName = "RateLimitModal";

const enhance = compose(
    ComponentWithRouter
);

export default enhance(RateLimitModal);
